export const UTM = {
  SOURCE: {
    SHARE: 'share',
  },
  MEDIUM: {
    SHARE: 'share',
  },
  CAMPAIGN: {
    INTENTION: (id: number): string => `Intention_${id}`,
    PUBLICATION: (id: number): string => `Publication_${id}`,
    COMMUNITY: (id: number): string => `Community_${id}`,
  },
}
